import {
  CreditAppEndStatuses,
  CreditProductIdentifiers,
} from '@paypalcorp/xo-credit-app-interface'
import { bundleLoaded, applicationDataLoaded, onApplicationReady } from './appLoadedState'
import { isInIframe } from './shared/utils/utils'


window.PAYPAL = {
  ...window.PAYPAL,
};
window.PAYPAL.creditApp = window.PAYPAL.creditApp || {};


// CRITICAL - ModXO calls initializeApp when the iframe is loaded
if (isInIframe()) {
  window.PAYPAL.creditApp.onAppLaunched = onAppLaunched
  window.PAYPAL.creditApp.initializeApp = async () => {
    try {
      const inputProps = window.PAYPAL?.checkout?.properties

      if (!inputProps) {
        throw new Error('PPDC: Missing checkout properties')
      }

      const { token, locale, selectedOfferId, euat } = inputProps

      const missingProps = ['token', 'locale', 'selectedOfferId', 'euat'].filter(prop => !inputProps[prop])
      
      if (missingProps.length) {
        if(missingProps.includes('euat')) {
          onError('auth')
        } else {
          onError('internal')
        }
      }

      // Initialize app state
      window.ppdcApp = {
        token,
        locale,
        selectedOfferId,
        euat,
        flow: 'ppdc_acquisition',
        creditProductIdentifier: CreditProductIdentifiers.PPDC_ACQUISITION_US,
        isReady: false,
        customerInteractions: [],
        atomicEventState: null,
      }

      onApplicationReady(window.PAYPAL.checkout?.signalAppLoaded)

      window.ppdcHandlers = {
        // Two-stage loading system (similar to capeuinodeweb)
        bundleLoaded: () => {
          try {
            bundleLoaded()
          } catch (error) { 
            signalAppEnded({ status: CreditAppEndStatuses.internalError })
          }
        },

        applicationDataLoaded: () => {
          try {
            applicationDataLoaded()
          } catch (error) { 
            signalAppEnded({ status: CreditAppEndStatuses.internalError })
          }
        },

        signalAppEnded,
        signalSuccess: onSuccess,
        signalCancel: onCancel,
        signalError: onError,
        signalDeclined: onDeclined,
        signalPending: onPending,
        signalTransition: onTransition,
        signalAuthError: () => onError('auth'),
        signalInternalError: () => onError('internal')
      }

      require('./render')

    } catch (error) {
      onError('internal')
    }
  }
}

// Step 5: To return to checkout, your app calls signalAppEnded
function signalAppEnded({ status }) {
  const customerInteractions = window.ppdcApp?.customerInteractions || []
  const atomicEventState = window.ppdcApp?.atomicEventState || undefined

  if (window.PAYPAL.checkout?.signalAppEnded) {
    window.PAYPAL.checkout.signalAppEnded({
      status,
      customerInteractions,
      atomicEventState,
    })
  }

}

// Step 4: XO calls onAppLaunched (after your app calls signalAppLoaded)
function onAppLaunched({
  customerInteractions = [],
  atomicEventState
} = { customerInteractions: [] }) {

  if (atomicEventState && window.ppdcApp) {
    window.ppdcApp.atomicEventState = atomicEventState
  }

  if (customerInteractions && customerInteractions.length > 0) {
    if (window.ppdcApp) {
      window.ppdcApp.customerInteractions = customerInteractions
    }
  }

  setTimeout(() => {
    const firstFocusableElement = document.querySelector('a, button, textarea, input, select')
    if (firstFocusableElement) {
      firstFocusableElement.focus()
    }
  }, 2000)

  if (window.ppdcApp) {
    window.ppdcApp.isReady = true
  }
}

function onCancel() {
  signalAppEnded({ status: CreditAppEndStatuses.canceled })
}

function onError(errorType = 'internal') {
  const status = errorType === 'auth' ? CreditAppEndStatuses.authError : CreditAppEndStatuses.internalError
  signalAppEnded({ status })
}

function onSuccess(_data = {}) {
  signalAppEnded({ status: CreditAppEndStatuses.approved })
}

function onDeclined(_data = {}) {
  signalAppEnded({ status: CreditAppEndStatuses.declined })
}

function onPending(_data = {}) {
  signalAppEnded({ status: CreditAppEndStatuses.pending })
}

function onTransition(_data = {}) {
  signalAppEnded({ status: CreditAppEndStatuses.transition })
}

export {
  signalAppEnded,
  onAppLaunched,
  onCancel,
  onError,
  onSuccess,
  onDeclined,
  onPending,
  onTransition,
}